export { default } from "./SetCouponBox-component";
